<div class="tooltip-content" [class.visible]="tooltip.visible()" [style.left.px]="tooltip.x()"
  [style.top.px]="tooltip.y()" (mouseenter)="tooltip.hoveringTooltip = true"
  (mouseleave)="tooltip.hoveringTooltip = false; tooltip.forceHide()">

  @if (tooltip.content()) {
    <ng-container [ngTemplateOutlet]="tooltip.content()"
      [ngTemplateOutletContext]="tooltip.context()">
    </ng-container>
  }

</div>